import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import * as T_T from 'cryface';

@Component
export default class PropertyInfoSummary extends Vue {
   public title: string = 'PropertyInfoSummary';

   @Prop()
   public data: any;

   public displayData: any = {
      id: 'N/A',
      zoning: 'N/A',
      ownership: 'N/A',
      propertyType: 'N/A',
      dom: 'N/A',
      type: 'N/A',
      city: 'N/A',
      community: 'N/A',
      garages: 'N/A',
      parkings: 'N/A',

      lotArea: 'N/A',
      usageArea: 'N/A',
      buildingArea: 'N/A',
      apxAge: 'N/A',
      builtYear: 'N/A',
      maintFee: 'N/A',
      frontOn: 'N/A',
      storeys: 'N/A',
      occupancyDate: 'N/A',
      brokerage: 'N/A'
   };

   @Watch('data', { immediate: true, deep: true })
   public onDataInput(val: any, oldVal: any) {
      if (T_T.simpleDetect(val)) {
         Object.keys(val).map((key: string) => {
            this.displayData[key] = this.dataMapper(val[key]);
         });
      }
   }

   public created() {
   }

   public dataMapper(data: string) {
      if (T_T.simpleDetect(data) && data !== '-') {
         return data;
      }
      return 'N/A';
   }
}
